import { Injectable } from '@angular/core';
import { Router } from "@angular/router";
import { ToasterService } from 'angular2-toaster';
import { LocalStorageService } from './storage/local-storage.service';
import { WebServiceService } from './web-service.service';
import { EesDesService } from './ees-des.service';

@Injectable()
export class LogoutService {

  company_meta: any = {};

  constructor(
    private _localStorageService: LocalStorageService,
    private router: Router,
    private toasterService: ToasterService,
    private webService: WebServiceService,
    private eesdesService: EesDesService
  ) { }

  getModule(url: string, arrayForSearch: any[]): any {
    let temp: any = [];
    temp = arrayForSearch.filter((v) => { return v.url == url })
    return temp[0] ? temp[0] : '';
  }

  getUserAccessToken(): string {
    return this.eesdesService.get('user_access_token', localStorage.getItem('user_access_token'))
  }

  validURL(str: string): boolean {
    var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
      '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
    return !!pattern.test(str);
  }

  isValidCookie(name: string): boolean {
    let status: boolean = false;
    switch (name) {
      case 'access_token':
        status = true;
        break;
      case 'accessrem':
        status = false;
        break;
      case 'accesskey':
        status = true;
        break;
      case 'accesstoken':
        status = true;
        break;
      default:
        status = false;
    }
    return status;
  }

  removeHttpCookie(payload: any): void {
    this.webService.commonPostMethod('login/cookies', payload).
      subscribe(
        data => {
          if (data.status) {
          }
          else {
          }
        }, error => {
          this.toasterService.pop("error", "Error", "Something Went Wrong");
        }
      );
  }

  deleteAllCookies(): void {
    var cookies = document.cookie.split(";");
    if (cookies.length > 0) {
      for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i];
        var eqPos = cookie.indexOf("=");
        var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;

        if (this.isValidCookie(name)) {
          this.removeHttpCookie({
            "action": "delete",
            "cookie_name": name,
            "user_id": this.company_meta.user_id ? this.company_meta.user_id : '',
            "user_role_id": this.company_meta.user_role_id ? this.company_meta.user_role_id : '',
            "company_id": this.company_meta.company_id ? this.company_meta.company_id : '',
          })
          document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
        }
      }
    }
  }

  saveLogoutActivity(payload: any): void {
    if (window.location.hostname == 'localhost') {
      // return;
    }
    this.webService.commonPostMethod('User_activity/save_user_activity', payload).
      subscribe(
        data => {
          if (data.status) {
            let after_logout_redirect_to_specific_url: any = this.eesdesService.get('after_logout_redirect_to_specific_url', localStorage.getItem('after_logout_redirect_to_specific_url')) ? this.eesdesService.get('after_logout_redirect_to_specific_url', localStorage.getItem('after_logout_redirect_to_specific_url')) : '';
            if (this.validURL(after_logout_redirect_to_specific_url)) {
              window.location.href = after_logout_redirect_to_specific_url
              window.localStorage.clear();
              window.sessionStorage.clear()
              this.deleteAllCookies()
            } else {
              window.localStorage.clear();
              window.sessionStorage.clear()
              this.deleteAllCookies()
              this.webService.redirectURL('/login');
            }

          } else {
            let after_logout_redirect_to_specific_url: any = this.eesdesService.get('after_logout_redirect_to_specific_url', localStorage.getItem('after_logout_redirect_to_specific_url')) ? this.eesdesService.get('after_logout_redirect_to_specific_url', localStorage.getItem('after_logout_redirect_to_specific_url')) : '';
            if (this.validURL(after_logout_redirect_to_specific_url)) {
              window.location.href = after_logout_redirect_to_specific_url
              window.localStorage.clear();
              window.sessionStorage.clear()
              this.deleteAllCookies()
            } else {
              window.localStorage.clear();
              window.sessionStorage.clear()
              this.deleteAllCookies()
              this.webService.redirectURL('/login');
            }

          }
        }, error => {
          let after_logout_redirect_to_specific_url: any = this.eesdesService.get('after_logout_redirect_to_specific_url', localStorage.getItem('after_logout_redirect_to_specific_url')) ? this.eesdesService.get('after_logout_redirect_to_specific_url', localStorage.getItem('after_logout_redirect_to_specific_url')) : '';
          if (this.validURL(after_logout_redirect_to_specific_url)) {
            window.location.href = after_logout_redirect_to_specific_url
            window.localStorage.clear();
            window.sessionStorage.clear()
          } else {
            window.localStorage.clear();
            window.sessionStorage.clear()
            this.webService.redirectURL('/login');
          }
        }
      );
  }

  destroyUserToken(payload: any): void {
    this.webService.commonPostMethod('User_session_management/destroy_token', payload).
      subscribe(
        data => {
          if (data.status) {
            this.saveLogoutActivity(payload);
          }
          else {
            if (this.eesdesService.get('emp_role', localStorage.getItem('emp_role')) != "administrator") {
              this.toasterService.pop("error", "Error", data.message);
            }
            window.sessionStorage.clear()
            window.localStorage.clear();
            window.location.href = "";
          }

        }, error => {
          this.toasterService.pop("error", "Error", "Something Went Wrong");
        }
      );
  }

  logout(arrayForSearch: any[] = [], type: any): void {
    this.webService.clearApiCache();
    let url: any = '';
    let moduleInfo: any = '';
    if(type == 'force'){
      url = "/dashboard";
      moduleInfo = '';
      
    }else{
      url = "/" + window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
      moduleInfo = this.getModule(url, arrayForSearch);
    }
 
    let payload: any = {
      "url": url,
      "project": moduleInfo.project ? moduleInfo.project : 'operation',
      "user_id": this._localStorageService.getUserId() ? this._localStorageService.getUserId() : '',
      "user_role_id": this._localStorageService.getUserRole() ? this._localStorageService.getUserRole() : '',
      "company_id": this._localStorageService.getEmpCompanyId() ? this._localStorageService.getEmpCompanyId() : '',
      "module_name": moduleInfo.menuName ? moduleInfo.menuName : '',
      "module_id": moduleInfo.id ? moduleInfo.id : '',
      "activity_type": 'logout',
      "full_url": window.location.href ? window.location.href : '',
      user_token: this.getUserAccessToken()
    }

    // Add user_expired_time to payload only when type is 'force'
    if(type == 'force'){
      let user_expired_time = localStorage.getItem('last_active_time');
      if(user_expired_time){
        // Convert ISO string to format: YYYY-MM-DD HH:mm:ss
        const date = new Date(user_expired_time);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        payload.user_expired_time = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      }
    }
    this.company_meta = {
      "url": url,
      "project": moduleInfo.project ? moduleInfo.project : 'operation',
      "user_id": this._localStorageService.getUserId() ? this._localStorageService.getUserId() : '',
      "user_role_id": this._localStorageService.getUserRole() ? this._localStorageService.getUserRole() : '',
      "company_id": this._localStorageService.getEmpCompanyId() ? this._localStorageService.getEmpCompanyId() : '',
      "module_name": moduleInfo.menuName ? moduleInfo.menuName : '',
      "module_id": moduleInfo.id ? moduleInfo.id : '',
      "activity_type": 'logout',
      "full_url": window.location.href ? window.location.href : '',
      user_token: this.getUserAccessToken()
    }
    this.destroyUserToken(payload);
  }
}




// WEBPACK FOOTER //
// /codebuild/output/src583407337/src/src/app/shared/services/logout.service.ts